import { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import { WebAppDevelopmentData } from "../../common";
// core components
import { Card, CardBody, CardHeader, CardTitle, Col, Container, Row } from "reactstrap";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import AboutUsBanner from "../../components/AboutUs/AboutUsBanner";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import ContactUsComponent from "../../components/ContactUsComponent/ContactUsComponent";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
import TechIndustryQuality from "../../components/TechIndustryQuality/TechIndustryQuality";
import { getIPGeoLocation } from "../../common/GeneralUtils";
// import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import * as Icons from '../../common/icons/webAppDevelopmentDataIcons';
import Toasts from "../../components/Toasts/Toasts";

// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const AboutUsBanner = Loadable(
//     lazy(() => import('../../components/AboutUs/AboutUsBanner'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const ContactUsComponent = Loadable(
//     lazy(() => import('../../components/ContactUsComponent/ContactUsComponent'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )
// const TechIndustryQuality = Loadable(
//     lazy(() => import('../../components/TechIndustryQuality/TechIndustryQuality'))
// )

const WebAppDevelopmentScreen = () => {
    const [toasts, setToasts] = useState(null)
    const [WebAppDevelopmentData, setData] = useState({});

    const getAllWebAppDevelopmentData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/webAppDevelopmentData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        getIPGeoLocation();
        getAllWebAppDevelopmentData();
    }, [])
    return (
        <Fragment>
            <Helmet>
                <title>Best Web App Development Service in Canada | Secure & Scalable Web Solutions</title>
                <meta name="description" content="Build powerful and scalable custom web applications with our expert development services in Canada. Secure, high-performance solutions designed for business transformation." />
                <meta name="keywords" content="web app development service, web app development service Canada, web app development service in Canada" />
                <meta property="og:title" content="Best Web App Development Service in Canada | Secure & Scalable Web Solutions" />
            </Helmet>
            <div id="main-wrapper">
                <Header />
                <div className="page-wrapper web-app-development-page-wrapper">
                    <div className="container-fluid">
                        <div className="page-content-top">
                            <AboutUsBanner bannerImg={WebAppDevelopmentData?.bannerImg} data={WebAppDevelopmentData?.headerData} />
                            <div className="content-tech-page-warper">
                                <Container>
                                    <div className="page-context-text">
                                        <h2>{WebAppDevelopmentData?.BuildFuture?.title}</h2>
                                        {WebAppDevelopmentData?.BuildFuture?.textData.map((text, index) => <p key={index}><span>{text?.text}</span> <span className="fw-bold">{text?.bold1}</span> <span>{text?.text1}</span> <span className="fw-bold">{text?.bold2}</span> <span>{text?.text2}</span></p>)}
                                    </div>
                                </Container>
                            </div>
                            <section className="why-mobile-app-development">
                                <Container>
                                    <Row>
                                        <Col lg={6} md={6} className="m-auto text-start">
                                            <div className="img-div-width">
                                                <LazyLoadImage
                                                    alt={'image'}
                                                    className="w-100"
                                                    src={WebAppDevelopmentData?.WhyMobileAppDevelopment?.pageImg} // use normal <img> attributes as props
                                                />
                                            </div>
                                            {/* <img src={tech?.pageImg} alt="img" /> */}
                                        </Col>
                                        <Col className="tech-page-warper px-5" lg={6} md={6}>
                                            <h3 className="pe-3">{WebAppDevelopmentData?.WhyMobileAppDevelopment?.title}</h3>
                                            <p>{WebAppDevelopmentData?.WhyMobileAppDevelopment?.paragraph}</p>
                                            <p>{WebAppDevelopmentData?.WhyMobileAppDevelopment?.paragraph1}</p>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className="web-app-Matters">
                                <Container>
                                    <h3>{WebAppDevelopmentData?.WhyWebAppDevelopmentMatters?.title}</h3>
                                    <h4>{WebAppDevelopmentData?.WhyWebAppDevelopmentMatters?.subtitle}</h4>
                                    <p className="pa-text py-4 m-0">{WebAppDevelopmentData?.WhyWebAppDevelopmentMatters?.paragraph}</p>
                                    <div className="core-mobile-app-card">
                                        <div className="d-flex gap-3">
                                            {WebAppDevelopmentData?.WhyWebAppDevelopmentMatters?.listData.map((list, index) => {
                                                return (
                                                    <Card key={index} className="app-card">
                                                        <CardHeader className="">
                                                            <CardTitle className="m-auto">{list?.title}</CardTitle>
                                                        </CardHeader>
                                                        <CardBody>
                                                            {list?.paragraph}
                                                        </CardBody>
                                                    </Card>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </Container>
                            </section>
                            <TechIndustryQuality techIndustryQualityData={WebAppDevelopmentData?.techIndustryQualityData} />
                            <section className="core-mobile-app-section">
                                <Container>
                                    <h3 className="text-center">{WebAppDevelopmentData?.CoreServices?.title}</h3>
                                    <h4>{WebAppDevelopmentData?.CoreServices?.subtitle}</h4>
                                    <div className="core-mobile-app-card">
                                        <Row className="m-0">
                                            {WebAppDevelopmentData?.CoreServices?.listData?.map((cardItem, index) => {
                                                const Icon = Icons[cardItem?.icon] || null;
                                                return <Col key={index} md={4} lg={4} sm={1}>
                                                    <Card className="app-card">
                                                        <CardBody>
                                                            <p>
                                                                {Icon && <Icon />}
                                                            </p>
                                                            <h5 className="card-title-div">{cardItem?.title}</h5>
                                                            <p><span>{cardItem?.text}</span>{cardItem?.bold && <span>{cardItem?.bold}</span>}{cardItem?.text1 && <span>{cardItem?.text1}</span>}</p>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            })}
                                        </Row>

                                    </div>
                                </Container>
                            </section>
                            <section className="technologies-we-used">
                                <Container>
                                    <Row>
                                        <Col className="tech-page-warper px-5" lg={6} md={6}>
                                            <h3 className="pe-3">{WebAppDevelopmentData?.TechnologiesWeUsed?.title}</h3>
                                            <p>{WebAppDevelopmentData?.TechnologiesWeUsed?.paragraph}</p>
                                            <ul>
                                                {WebAppDevelopmentData?.TechnologiesWeUsed?.listData?.map((list, index) => {
                                                    return (
                                                        <li key={index}>
                                                            <span className="span-title">{list?.title}</span> <span>{list?.text}</span>
                                                        </li>
                                                    )
                                                })}
                                            </ul>

                                        </Col>
                                        <Col lg={6} md={6} className="m-auto text-start">
                                            <div className="img-div-width">
                                                <LazyLoadImage
                                                    alt={'image'}
                                                    className="w-100"
                                                    src={WebAppDevelopmentData?.TechnologiesWeUsed?.pageImg} // use normal <img> attributes as props
                                                />
                                            </div>
                                            {/* <img src={tech?.pageImg} alt="img" /> */}
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className="choose-varahi-Soft">
                                <Container>
                                    <Row>
                                        <Col lg={6} md={6} className="m-auto text-start">
                                            <div className="img-div-width m-auto">
                                                <LazyLoadImage
                                                    alt={'image'}
                                                    className="w-100"
                                                    src={WebAppDevelopmentData?.ChooseVarahiSoft?.pageImg} // use normal <img> attributes as props
                                                />
                                            </div>
                                            {/* <img src={tech?.pageImg} alt="img" /> */}
                                        </Col>
                                        <Col className="tech-page-warper px-5" lg={6} md={6}>
                                            <h3 className="pe-3">{WebAppDevelopmentData?.ChooseVarahiSoft?.title}</h3>
                                            <p>{WebAppDevelopmentData?.ChooseVarahiSoft?.paragraph}</p>
                                            <ul>
                                                {WebAppDevelopmentData?.ChooseVarahiSoft?.listData?.map((list, index) => {
                                                    return (
                                                        <li key={index}>
                                                            <span className="span-title">{list?.title}</span> <span>{list?.text}</span>
                                                        </li>
                                                    )
                                                })}
                                            </ul>

                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className='core-mobile-app-build-somethingAmazingTogether-div' style={{ backgroundImage: `url(${WebAppDevelopmentData?.BuildSomethingAmazingTogether?.bgImg})` }}>
                                <div className="client-count text-white">
                                    <Container>
                                        <Row className='Fre8-Pro'>
                                            <Col lg="8" md='7' className='ps-0 m-auto d-flex justify-content-center align-items-center gap-5'>
                                                <div className="display-7 align-self-center">
                                                    <h3 className='mb-3'>{WebAppDevelopmentData?.BuildSomethingAmazingTogether?.title}</h3>
                                                    <p>{WebAppDevelopmentData?.BuildSomethingAmazingTogether?.paragraph?.text}<Link className='text-decoration-none text-white' to={window?.location?.origin}>{WebAppDevelopmentData?.BuildSomethingAmazingTogether?.paragraph?.link}</Link> {WebAppDevelopmentData?.BuildSomethingAmazingTogether?.paragraph?.text1}</p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                            </section>
                            <CustomerReviews />
                            <div className="home-contact-page">
                                <ContactUsComponent setToasts={setToasts} />
                            </div>
                            <FrequentlyAskedQuestions faqData={WebAppDevelopmentData?.FrequentlyAskedQuestionsData} />
                        </div>
                    </div>
                </div>
                <Footer />
                {toasts && <Toasts toastsList={toasts} />}
            </div>
        </Fragment>
    );
}

WebAppDevelopmentScreen.propTypes = {
    classes: PropTypes.object
};

export default WebAppDevelopmentScreen;
